import React from "react";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { CtaButton } from "../../../Elements";

import { AlumniImage, Subtitle, Title, Logo, Container } from "./styles";

const Card = React.memo(({ alumni = {}, darkBg }) => {
	const alumniData = alumni?.content?.alumni_data;
	const featuredAlumniData = alumni?.content?.featuredAlumniData;
	const [featuredAlumni] = featuredAlumniData || [];

	let ctaButton;
	if (featuredAlumni?.cta) {
		const {
			buttonText = "",
			link: { type: linkType = "", link = "", target = "_self" } = {},
			type = "",
		} = featuredAlumni.cta[0];

		ctaButton = {
			text: buttonText,
			darkBg,
			link: {
				type: linkType,
				value: link,
				target,
			},
			type,
		};
	}
	return (
		<Container>
			<AlumniImage>
				<CloudinaryImage
					lazyload
					url={(alumniData || [])[0]?.avatar?.image}
					sizes={{ default: { height: 242 } }}
				/>
			</AlumniImage>
			<Subtitle
				dangerouslySetInnerHTML={{
					__html: featuredAlumni?.subtitle?.html,
				}}
			/>
			<Title
				dangerouslySetInnerHTML={{
					__html: featuredAlumni?.title?.html,
				}}
			/>
			<Logo>
				<CloudinaryImage
					lazyload
					url={featuredAlumni?.company_logo?.image}
					sizes={{ default: { height: 200 } }}
				/>
			</Logo>
			<CtaButton cta={ctaButton}></CtaButton>
		</Container>
	);
});

export default Card;
